<template>
  <div>
    <header>
      <div class="header">
        <div>
          <gl-button @click="moveToList">一覧へ</gl-button>
        </div>
      </div>
    </header>

    <div class="contents">
      <!-- -------------------------------------------------------- -->
      <!-- 分析条件 -->
      <!-- -------------------------------------------------------- -->
      <div class="filter">
        <!-- 基本 -->
        <query-filter-element id="basic" title="基本条件" contentWidth="medium">
          <div class="company">
            <div class="title">
              <gl-sub-text>対象企業</gl-sub-text>
            </div>
            <gl-select-company :company.sync="queryFilter.basic.company" />
          </div>

          <filter-mouse-pos-basic v-bind.sync="queryFilter.basic" />
        </query-filter-element>

        <!-- 期間 -->
        <query-filter-element id="term" title="期間" contentWidth="medium">
          <filter-term-pos
            v-bind.sync="queryFilter.term"
            :default-week-count="8"
            :isCompareToggleVisible="false"
            :isCompareEnabled="false"
          />

          <div class="termSummaryTypes">
            <div class="title">
              <gl-sub-text>集計方法</gl-sub-text>
            </div>
            <md-radio v-model="queryFilter.term.termSummaryType" value="daily"
              >日別でデータダウンロード</md-radio
            >
            <md-radio
              v-model="queryFilter.term.termSummaryType"
              value="termType"
              >{{
                termSummaryText
              }}に集計（期間選択で指定した単位で集計します）</md-radio
            >
            <md-radio v-model="queryFilter.term.termSummaryType" value="range"
              >期間範囲の合計</md-radio
            >
          </div>
        </query-filter-element>

        <!-- 商品分類 -->
        <query-filter-element id="item" title="商品分類">
          <div>
            <md-radio v-model="queryFilter.item.selectMode" value="category">
              分類
              <gl-sub-text>で指定</gl-sub-text>
            </md-radio>
            <md-radio v-model="queryFilter.item.selectMode" value="item">
              商品
              <gl-sub-text>で指定</gl-sub-text>
            </md-radio>
          </div>
          <filter-item-category
            v-if="queryFilter.item.selectMode === 'category'"
            v-bind.sync="queryFilter.item"
            :company.sync="queryFilter.basic.company"
            :pos-restriction="true"
          />
          <filter-item
            v-if="queryFilter.item.selectMode === 'item'"
            v-bind.sync="queryFilter.item"
            :company.sync="queryFilter.basic.company"
            :pos-restriction="true"
          />
        </query-filter-element>

        <!-- 店舗 -->
        <query-filter-element id="store" title="店舗" contentWidth="medium">
          <filter-store
            v-bind.sync="queryFilter.store"
            :company.sync="queryFilter.basic.company"
          />
        </query-filter-element>

        <!-- オプション-->
        <query-filter-element
          id="option"
          title="オプション"
          contentWidth="medium"
        >
          <gl-sub-text>
            文字コード
          </gl-sub-text>
          <div>
            <md-radio v-model="queryFilter.option.encoding" value="utf-8">
              UTF-8
            </md-radio>
            <md-radio v-model="queryFilter.option.encoding" value="s-jis">
              S-JIS
            </md-radio>
          </div>
          <!-- <gl-sub-text>
            圧縮
          </gl-sub-text>
          <div>
            <md-radio v-model="queryFilter.option.compression" value="zip">
              ZIP
            </md-radio>
            <gl-sub-text>※ZIPのみ対応</gl-sub-text>
          </div> -->
        </query-filter-element>
      </div>
      <div v-if="this.hasInvalidInput" class="fixed-error-message-area">
        <gl-error-text :errors="this.invalidMessages" />
      </div>
      <transition name="query-button">
        <div
          class="fixed-action-area"
          :gl-tooltip="buttonToolTip"
          gl-tooltip-direction="left"
        >
          <button-execute-query
            @click="executeQuery"
            class="animated"
            :disabled="!(canStartQuery && canPageSwitch)"
            :will-plane-fly="canStartQuery"
            :class="{ tada: canStartQuery }"
          />
        </div>
      </transition>
    </div>

    <!-- 分析条件復元失敗エラーダイアログ -->
    <md-dialog-alert
      :md-active.sync="showFailedToApplyQueryFilter"
      md-content="分析条件の読込に失敗しました。保存されていた分析条件は削除されます。"
      md-confirm-text="Close"
    />
    <!-- </mouse-layout> -->
  </div>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
// import MouseLayout from '@/components/layout/MouseLayout.vue'
// 分析条件サマリ
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterMousePosBasic from '@/components/FilterMousePosBasic.vue'
import FilterTermPos from '@/components/FilterTermPos.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'
import FilterItem from '@/components/FilterItem.vue'
import FilterStore from '@/components/FilterStore.vue'
// 分析条件モデル
import basic from '@/queryfilter/mousePosBasic'
import termPos from '@/queryfilter/termPos'
import item from '@/queryfilter/itemMouse'
import store from '@/queryfilter/store'
import ButtonExecuteQuery from '@/components/ButtonExecuteQuery'
// import Spinner from '@/components/Spinner.vue'

export default {
  components: {
    QueryFilterElement,
    FilterMousePosBasic,
    FilterTermPos,
    FilterItem,
    FilterItemCategory,
    FilterStore,
    // Spinner,
    ButtonExecuteQuery,
  },
  data() {
    return {
      loading: false,
      waitingPageSwitch: false,

      /**
       * 分析条件
       */
      queryFilter: {
        basic: { ...basic.get() },
        term: {
          termSummaryType: 'daily',
          summaryKey: 'termPos',
          ...termPos.get(),
          visibleTermTypes: ['d', 'w', 'm', 'closing'],
        },
        item: { ...item.get() },
        store: { ...store.get() },
        option: {
          encoding: 'utf-8',
          compression: 'zip',
        },
      },
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: queryFilter => {
        // Mouseでは商品分類の選択モード（分類or商品）が必要です。
        // 本家ではmapToApiPayloadで作成されますがこちらにはないので
        // 後付します。
        const _item = item.mapToApiPayload(queryFilter.item)
        _item.selectMode = queryFilter.item.selectMode

        return {
          company: queryFilter.basic.company,
          description: queryFilter.basic.description,
          type: queryFilter.basic.type,
          groupKeys: queryFilter.basic.groupKeys,
          optionalDownloads: queryFilter.basic.optionalDownloads,
          term: {
            termSummaryType: queryFilter.term.termSummaryType,
            // @memo 分析条件の保存のためにTermTypeを入れる。（Mouseは条件保存がAPIのqueryFilterの型通りなので）
            // のちのちTermPos.jsの方でbase、compareの中に持つのではなくtermの直下に
            // termTypeを持つようになったら不要。
            termType: queryFilter.term.termType,
            ...termPos.mapToApiPayload(queryFilter.term),
          },
          item: _item,
          store: store.mapToApiPayload(queryFilter.store),
          option: {
            encoding: queryFilter.option.encoding,
            compression: queryFilter.option.compression,
          },
        }
      },
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       *
       * 渡される分析条件はこの画面のものとは限らないので、"可能な限り"復元する。
       */
      applyQueryFilter: queryFilter => {
        this.queryFilter.basic.description = queryFilter.description
        this.queryFilter.basic.company = queryFilter.company
        this.queryFilter.basic.type = queryFilter.type || 'bizoope'
        this.queryFilter.basic.groupKeys = queryFilter.groupKeys || [
          'term',
          'item',
          'store',
        ]
        this.queryFilter.basic.optionalDownloads = queryFilter.optionalDownloads
        termPos.applyPayload(this.queryFilter.term, queryFilter.term)
        this.queryFilter.term.termSummaryType =
          queryFilter.term.termSummaryType || 'daily'
        item.applyPayload(
          this.queryFilter.item,
          queryFilter.item,
          queryFilter.company,
        )
        store.applyPayload(this.queryFilter.store, queryFilter.store)

        this.queryFilter.option.encoding = queryFilter.option.encoding
        this.queryFilter.option.compression = queryFilter.option.compression
      },
      /**
       * 分析条件の復元失敗エラーダイアログの開閉状態
       */
      showFailedToApplyQueryFilter: false,
    }
  },
  methods: {
    async executeQuery() {
      this.waitingPageSwitch = true
      await this.$repositories
        .get('downloadRequest')
        .create(this.mapQueryFilterForApi(this.queryFilter))

      //結果は待たず、一覧へ戻る
      this.$router.push({ name: 'query-mouse-pos' })
      this.waitingPageSwitch = false
    },
    openHelp() {
      window.open(`${process.env.VUE_APP_HELP_SITE_URL_BASE}mouse.html`)
    },
    moveToList() {
      this.$router.push({ name: 'query-mouse-pos' })
    },
  },
  computed: {
    /**
     * クエリの発行ができる状態か否か
     */
    canStartQuery() {
      return !this.hasInvalidInput
    },
    canPageSwitch() {
      return !this.waitingPageSwitch
    },
    /**
     * 分析ボタンツールチップ
     */
    buttonToolTip() {
      if (this.hasInvalidInput) {
        return '分析条件に入力エラーがあります。'
      }
      return ''
    },
    hasInvalidInput() {
      return (
        Object.entries(this.queryFilter)
          .map(e => e[1])
          .map(e => (e['errors'] ? e.errors : []))
          .filter(e => e.length > 0).length > 0
      )
    },
    invalidMessages() {
      const messages = Object.entries(this.queryFilter)
        .map(e => e[1])
        .map(e => (e['errors'] ? e.errors : []))
        .filter(e => e.length > 0)
        .flat()

      return messages
    },
    termSummaryText() {
      if (this.queryFilter.term.termType === 'w') {
        return '週別'
      } else if (this.queryFilter.term.termType === 'm') {
        return '月別'
      } else if (this.queryFilter.term.termType === 'd') {
        return '日別'
      } else if (this.queryFilter.term.termType === 'closing') {
        return '月度別'
      }
      return ''
    },
  },
  watch: {
    '$route.params.requestId': {
      immediate: true,
      async handler(requestId) {
        if (requestId) {
          this.loading = true
          const queryFilter = await this.$repositories
            .get('downloadRequest')
            .getQueryFilter(requestId)

          const promises = this.applyQueryFilter(queryFilter)
          if (promises && promises.length > 0) {
            await Promise.all(promises.filter(p => p))
          }

          this.loading = false
        } else {
          this.queryFilter.basic.company = this.$store.state.companies[0].code
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
$header-height: 72px;

header {
  align-items: center;
  display: flex;
  background-color: var(--bg-color-primary);
  border-bottom: 2px solid var(--color-border);
  flex-direction: columns;
  height: 74px;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  justify-content: flex-end;
}

.title {
  margin-top: var(--spacing-medium);
}
.contents {
  padding-bottom: var(--spacing-large);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-large);
  // TODO ヘッダの高さはCSS変数で良い気がする。
  padding-top: calc(72px + var(--spacing-large));
  width: 100%;
}

.header {
  background: #fff;
  height: $header-height;
  top: 0;
  left: 0;
  right: 0;
  padding-right: var(--spacing-large);
  opacity: 0.9;
  position: fixed;
  z-index: 11;

  display: flex;
  align-items: center;

  .align-left {
    flex: 1;
    margin-left: var(--spacing-large);
  }
}

.header-actions {
  display: flex;
  align-items: center;
}

.filter {
  // 分析条件内に描画される分析条件パネルの表示位置はここで制御します。
  .query-filter-element {
    margin-top: var(--spacing-large);
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: var(--spacing-large);
    }
  }
}

.fixed-action-area {
  position: fixed;
  bottom: var(--spacing-medium);
  right: var(--spacing-medium);
  z-index: 11;
}

.fixed-error-message-area {
  background-color: var(--bg-color-primary);
  border: 1px solid var(--color-border);
  position: fixed;
  bottom: calc(var(--spacing-medium) + 48px);
  right: var(--spacing-medium);
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  margin-bottom: var(--spacing-medium);
  border-radius: 5px;
  z-index: 12;
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}
.slide-in-enter,
.slide-in-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.query-button-enter-active,
.query-button-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}
.query-button-enter,
.query-button-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
